import api from '../../services/api';

export default (payload, action) => api('PutClientLocation', {
  clientLocation: payload,
  action,
});
